module.exports = __webpack_public_path__ + "static/media/teaRoom.e5467270.jpg";